import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';

@Component({
  selector: 'axis-alert,[axis-alert]',
  templateUrl: './alert.component.html',
  host: {
    '[class.axis-alert-wrapper]': '!closed'
  }
})
export class AlertComponent implements OnInit, AfterViewInit {
  @Input() public closed = false;
  @Input() public top: string;
  @Input() public dismissible: boolean;
  @Input() public autoClose = true;
  @Input() public datafadeout = false;
  @Input() public isNotificationVisible = false;
  // tslint:disable-next-line: no-input-rename
  @Input('data-inline') public inline: string;
  // tslint:disable-next-line: no-input-rename
  @Input('data-kind') public kind = 'warning'; // To apply css in ng9, input name should be data-kind.
  // tslint:disable-next-line: max-line-length
  @Input() public type = ''; // type can be empty(for default alert), 'notification' (for notification alert on button click), or 'accordion'(for accordion featured alert).
  @Input() public timeOut = 3000;
  @Input() font = 'custom';

  @Output() public onClose: EventEmitter<AlertComponent> = new EventEmitter<AlertComponent>(false);

  @ViewChild('headingRightContent') headingRightContent: ElementRef;

  public headingRightContentExist = false;
  public classes: Array<string> = [];
  public active = false;
  public content = '';
  public alertService = false;
  public alertHeadingRight = false;
  public alertHeadingContent ='';
  public alertBodyContent = '';
  public alertHeadingRightContent = '';

  constructor(private elementRef: ElementRef,
    private cd: ChangeDetectorRef) { }

  public ngOnInit(): any {
    if (this.type) {
      this.type = this.type.toLowerCase();
    }
    if (this.datafadeout) {
      setTimeout(() => this.close(), this.timeOut);
    }
  }

  ngAfterViewInit() {
    // if alert type is accordion and if 'axis-alert-heading-right' exist, then do not show cross icon close button.
    if (this.type === 'accordion') {
      if (this.headingRightContent && this.headingRightContent.nativeElement &&
        this.headingRightContent.nativeElement.nextSibling &&
        this.headingRightContent.nativeElement.nextSibling.localName === 'axis-alert-heading-right') {
        this.headingRightContentExist = true;
        this.cd.detectChanges();
      }
    }
  }

  public close(): void {
    if (!this.closed && this.type !== 'notification') {
      this.closed = true;
    } else if (this.type === 'notification' && !this.closed) {
      this.isNotificationVisible = false;
    }
    this.onClose.emit(this);
  }

  public openAlert(): void {
    this.isNotificationVisible = true;
    this.closed = false;
    if (this.type === 'notification' && this.autoClose) {
      setTimeout(() => this.close(), this.timeOut);
    }
  }

  public toggleAccordion(e): void {
    this.active = !this.active;
  }
}
@Component({
  selector: 'axis-notification',
  template: '<ng-content></ng-content>'
})
export class AxisNotificationComponent { }

@Component({
  selector: 'axis-alert-heading',
  template: '<ng-content></ng-content>',
  host: { class: 'axis-alert-heading' }
})
export class AxisAlertHeadingComponent { }

@Component({
  selector: 'axis-alert-heading-right',
  template: '<ng-content></ng-content>',
  host: { class: 'axis-alert-heading-right' }
})
export class AxisAlertHeadingRightComponent { }


@Component({
  selector: 'axis-alert-body',
  template: '<ng-content></ng-content>',
  host: { class: 'axis-alert-body' }
})
export class AxisAlertBodyComponent { }
